import { Dialog, DialogPanel, DialogTitle, Description } from '@headlessui/react';
import SharedButton from '../Button/Button';
import { SharedDialogProps } from '../../types';
import clsx from 'clsx';

function SharedDialog({
  isOpen,
  onClose,
  title,
  description,
  children,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  hasConfirmBtn,
  size = 'md',
  className = '',
}: SharedDialogProps) {
  const baseStyles = 'overflow-y-auto space-y-4 border bg-white p-12 rounded-md shadow-xl';
  const sizeStyles = {
    xs: 'max-w-2xl',
    sm: 'max-w-3xl',
    md: 'max-w-4xl min-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-8xl',
  }[size];

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 flex w-screen items-center justify-center p-4 z-50"
        style={{ background: '#00000059' }}
      >
        <DialogPanel className={clsx(baseStyles, sizeStyles, className)} style={{ maxHeight: '80vh' }}>
          {title && <DialogTitle className="font-bold text-xl">{title}</DialogTitle>}
          {description && <Description className="text-gray-600">{description}</Description>}
          {children && <div>{children}</div>}
          <div className="flex justify-end gap-1 pt-4">
            {hasConfirmBtn && <SharedButton onClick={onConfirm}>{confirmText}</SharedButton>}
            <SharedButton onClick={onClose}>{cancelText}</SharedButton>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}

export default SharedDialog;
